import { render, staticRenderFns } from "./department_manager.vue?vue&type=template&id=66f78d6b&scoped=true"
import script from "./department_manager.vue?vue&type=script&lang=js"
export * from "./department_manager.vue?vue&type=script&lang=js"
import style0 from "./department_manager.vue?vue&type=style&index=0&id=66f78d6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f78d6b",
  null
  
)

export default component.exports